import type { IconSvgObject } from './types';

const HtmlFiveIcon: IconSvgObject = [
  ["path", { d: "M19.5 18L21.5 2H2.5L4.5 18L12 22L19.5 18Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16.5 6H7.5L7.99965 10.5H15.9996L15.4996 16L11.9996 17L8.49965 16L8 13.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default HtmlFiveIcon;
